import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { useTranslate } from '@growtherapy/i18n';

import { unreadMessagesCountFamily } from '../../session/state';
import { setFaviconAndTitleBasedOnUnreadMessagesCount } from '../chat/utils';
import { activeConversationSidAtom } from '../state';

export function useResetFaviconAndTitleCallback() {
  const t = useTranslate();
  const getActiveConversationSid = useAtomCallback(useCallback((get) => get(activeConversationSidAtom), []));
  const getUnreadMessagesCount = useAtomCallback(
    useCallback(
      (get, _set, activeConversationSid?: string) => get(unreadMessagesCountFamily(activeConversationSid ?? '')),
      [],
    ),
  );

  return useCallback(() => {
    const activeConversationSid = getActiveConversationSid();
    const unreadMessagesCount = getUnreadMessagesCount(activeConversationSid);
    setFaviconAndTitleBasedOnUnreadMessagesCount(unreadMessagesCount, t('telehealth-core:meta.waitingRoom'));
  }, [t, getActiveConversationSid, getUnreadMessagesCount]);
}
